import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomModal, SessionExpiredModal } from "../../components";
import MigratePage from "./MigratePage";
import WelcomePage from "./WelcomePage";
import { isSessionExpired, getPreprocessedData } from "../../utils/Helper";
import { ApiService } from "../../utils/ApiService";
import { API_URL } from "../../utils/Constants";
import { LandingPageStyled } from "./styled";
import { ROUTES } from "../../config/routes";
import { MIGRATE_PAGE_CONSTANTS } from "../../config/constants";

const LandingPageV2 = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [studentValueList, setStudentValueList] = useState([]);
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [merchantId, setMerchantId] = useState("");
  const [isSearchFound, setIsSearchFound] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const [schoolName, setSchoolName] = useState("");
  const [category, setCategory] = useState("");
  const [currency, setCurrency] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [iconUrl, setIconUrl] = useState("");
  const [website, setWebsite] = useState("");
  const [twitter, setTwitter] = useState("");
  const [migrateMsg, setMigrateMsg] = useState("");
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    const url = API_URL.MERCHANT + "?offset=" + pageNo + "&limit=" + pageSize;
    const getMerchantList = async () => {
      const response = await ApiService.getRequest(url);
      if (response?.status?.code === "Y") {
        setStudentValueList(getPreprocessedData(response?.body));
        if (studentValueList.length > 0) setLoader(false);
        setTotalCount(response?.status?.message);
      }
    };
    let screenWidth = window.innerWidth;
    if (screenWidth < 420) {
      setMobileView(true);
    }
    getMerchantList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    !loader && refreshMerchantList();
    setLoader(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNo, pageSize]);

  const refreshMerchantList = async () => {
    const url = API_URL.MERCHANT + "?offset=" + pageNo + "&limit=" + pageSize;
    const response = await ApiService.getRequest(url);
    if (isSessionExpired(response)) {
      navigate(ROUTES.LOGIN);
      return;
    }
    // setTotalCount(parseInt(response?.status?.message));
    // setStudentValueList(response?.body);
      setStudentValueList(getPreprocessedData(response.body));
      setTotalCount(response?.status?.message);
    setLoader(false);
  };

  const onSync = async (params) => {
    const url = API_URL.SYNC_MERCHANT + params.data.merchantId;
    try {
      await ApiService.getRequest(url);
    } catch (e) {
      console.error(e);
    }
    refreshMerchantList();
  };

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchString(value);
    fetchSearchedSchools(value);
  };

  const onPageSizeChanged = (event) => setPageSize(event?.target?.value);

  const onLeftArrow = () => setPageNo(pageNo - 1);

  const onRightArrow = () => setPageNo(pageNo + 1);

  const fetchSearchedSchools = async (searchValue) => {
    if (searchValue?.length === 0 || !searchValue) {
      refreshMerchantList();
    } else {
      const url =
        API_URL.FETCH_MERCHANT_WILDCARD +
        searchValue +
        "?offset=0&limit=" +
        pageSize;

      const resp = await ApiService.getRequest(url);

      if (resp?.status?.code === "Y") {
        setStudentValueList(getPreprocessedData(resp.body));
        setTotalCount(resp?.status?.message);
      }
    }
  };

  const onSearch = async () => {
    const url = API_URL.GET_MERCHANT_DATA + searchText;
    try {
      const response = await ApiService.getRequest(url);
      if (response.status.code === "Y") {
        setIsSearchFound(true);
        setIsSearched(true);
        setSchoolName(response.body.name);
        setCategory(response.body.category);
        setCurrency(response.body.defaultCurrency);
        setImageUrl(response.body.imageUrl);
        setIconUrl(response.body.icon);
        setWebsite(response.body.website);
        setTwitter(response.body.twitter);
        setMerchantId(response.body.id);
      } else {
        setIsSearchFound(false);
        setIsSearched(true);
      }
    } catch (err) {
      setIsSearched(true);
      setIsSearchFound(false);
      console.error("Error fetching merchant data:", err);
    }
  };
  const onMigrate = async () => {
    const url = API_URL.MIGRATE_DATA + merchantId;
    try {
      const response = await ApiService.getRequest(url);
      setMigrateMsg(response.status.message);
      setShowModal(true);
    } catch (err) {
      console.error("Error migrating merchant data:", err);
      setMigrateMsg(MIGRATE_PAGE_CONSTANTS.ERROR_MIGRATING);
    }
  };

  const backButonHadler = () => {
    setIsSearchFound(false);
    setIsSearched(false);
    setSearchString("");
    refreshMerchantList();
    navigate(ROUTES.MAIN_LANDING_PAGE);
  };

  const changeSearchText = (id) => {
    setIsSearchFound(false);
    setIsSearched(false);
    setSearchText(id);
  };

  const onHideModal = () => {
    setShowModal(false);
  };

  return (
    <LandingPageStyled>
      <CustomModal
        show={showModal}
        onHide={onHideModal}
        title={MIGRATE_PAGE_CONSTANTS.MIGRATE_SUCCESS}
        message={migrateMsg}
      />
      {state?.fromScreen === "migrateFromQKR" ? (
        <MigratePage
          onSearch={onSearch}
          onMigrate={onMigrate}
          searchText={searchText}
          setSearchText={changeSearchText}
          backButonHadler={backButonHadler}
          loader={loader}
          isSearched={isSearched}
          issearchFound={isSearchFound}
          merchantId={merchantId}
          schoolName={schoolName}
          category={category}
          currency={currency}
          imageURL={imageUrl}
          twitter={twitter}
          website={website}
          iconUrl={iconUrl}
        />
      ) : (
        <WelcomePage
          pageSize={pageSize}
          onPageSizeChanged={onPageSizeChanged}
          pageNo={pageNo}
          totalCount={totalCount}
          onLeftArrow={onLeftArrow}
          onRightArrow={onRightArrow}
          searchString={searchString}
          onSearch={handleSearch}
          studentValueList={studentValueList}
          onSync={onSync}
          loader={loader}
        />
      )}
      <SessionExpiredModal
        show={mobileView}
        onHide={() => setMobileView(false)}
        title={"For better experience please use the desktop version"}
        subTitle={""}
        buttonText={"Close"}
        showSubTitle
      />
    </LandingPageStyled>
  );
};

export default LandingPageV2;
